import { SIZE_4_GB } from './uploads';

export const MOBILE_EMULATOR_MAX_FILE_SIZE: number = SIZE_4_GB;
export const MOBILE_EMULATOR_MAX_FILE_SIZE_DECIMALS: number = 0;
